import { Config } from '@chegg-wt/core/config'
import '@chegg-wt/core/types/global'
import { CITATION_LIST_NAME_LOWER_SINGLE } from '../constants/citations'

export interface GoogleDocResponse {
  url?: string
  error?: string
}

let GoogleAuth
const SCOPE = 'https://www.googleapis.com/auth/drive'
let bibFile
let bibTitle

const saveBibToDrive = (accessToken: string) => {
  return new Promise<GoogleDocResponse>((resolve, reject) => {
    const metadata = {
      name: bibTitle,
      mimeType: 'application/vnd.google-apps.document',
    }

    const form = new FormData()
    form.append(
      'metadata',
      new Blob([JSON.stringify(metadata)], { type: 'application/json' })
    )
    form.append('file', bibFile)

    const xhr = new XMLHttpRequest()
    xhr.open(
      'post',
      'https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart'
    )
    xhr.setRequestHeader('Authorization', `Bearer ${accessToken}`)
    xhr.responseType = 'json'
    xhr.onload = () => {
      const url = `https://docs.google.com/document/d/${xhr.response.id}/edit`
      try {
        resolve({ url })
      } catch (e) {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({ error: 'Whoops, something went wrong.' })
        // console.error(e, null, { Callback })
      }
      return { url }
    }
    xhr.onerror = () => {
      // eslint-disable-next-line prefer-promise-reject-errors
      reject({ error: 'Whoops, something went wrong.' })
      // console.error(error)
    }
    xhr.send(form)
  })
}

const setSigninStatus = () => {
  const user = GoogleAuth.currentUser.get()
  const isAuthorized = user.hasGrantedScopes(SCOPE)
  const userResponse = isAuthorized && user.getAuthResponse()

  if (userResponse) {
    return saveBibToDrive(userResponse.access_token)
  }
  return Promise.resolve<GoogleDocResponse>({
    error: `You have not authorized Google Drive, so we cannot save your ${CITATION_LIST_NAME_LOWER_SINGLE} there.`,
  })
}

export const saveToDrive = (file: any, title: string) => {
  bibFile = file
  bibTitle = title
  return setSigninStatus()
}

export const isSignedIntoGoogle = () => GoogleAuth && GoogleAuth.isSignedIn.get()

export const signInToGoogle = async () => {
  if (!isSignedIntoGoogle()) await GoogleAuth.signIn()
}

const initClient = () => {
  // Retrieve the discovery document for version 3 of Google Drive API.
  // In practice, your app can retrieve one or more discovery documents.
  const discoveryUrl = 'https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'

  // Initialize the gapi.client object, which app uses to make API requests.
  // Get API key and client ID from API Console.
  // 'scope' field specifies space-delimited list of access scopes.
  return window.gapi.client
    .init({
      apiKey: Config.googleAPIKey,
      discoveryDocs: [discoveryUrl],
      clientId: Config.googleClientId,
      scope: SCOPE,
    })
    .then(() => {
      GoogleAuth = window.gapi.auth2.getAuthInstance()
    })
}

export const initGoogleAuth = () => {
  if (!GoogleAuth) {
    return new Promise((resolve, reject) => {
      const waitForGapi = setInterval(() => {
        if (window.gapi) {
          window.gapi.load('client:auth2', function load() {
            initClient().then(resolve).catch(reject)
          })
          clearInterval(waitForGapi)
        }
      }, 100)
      setTimeout(() => {
        clearInterval(waitForGapi)
        reject()
      }, 5000)
    })
  }
  return Promise.resolve()
}

export const googleApi = {
  initGoogleAuth,
  signInToGoogle,
  saveToDrive,
  isSignedIntoGoogle,
}
